import alert from '@/plugins/alert'
import { Major, Upload, Course } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    major: {
    },
    courses: []
  },
  actions: {

    async fetchMajor ({ commit }, majorId) {
      const major = await Major.fetchOne(majorId)
      commit('setMajor', major)
      commit('setCourses', major.courses)
    },

    async updateMajor ({ commit }, { id, ...major }) {
      try {
        const majorData = await Major.update(id, major)
        commit('setMajor', majorData)
        commit('setCourses', majorData.courses)
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    setMajor ({ commit, state }, major) {
      commit('setMajor', major)
    },
    async createCourse ({ commit }, { major, data, options }) {
      try {
        if (!major.courses) major.courses = []
        const course = await Course.create(data, options)
        commit('updateCourse', course)
      } catch (e) {
        alert.error(e)
      }
    },
    async uploadAvatar ({ commit }, { majorId, formData }) {
      try {
        let data = await Upload.upload(formData)
        commit('setAvatar', { majorId, avatar: data[0] })
        alert.success('Upload successfully!')
      } catch (e) {
        alert.error(e)
      }
    },
    async destroyAvatar ({ commit }, id) {
      try {
        await Upload.destroy(id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setCourses (state, courses) {
      state.courses = courses
    },
    updateCourses (state, course) {
      state.courses = [...state.course, course]
    },
    setMajor (state, major) {
      state.major = major
    },
    setAvatar (state, { majorId, avatar }) {
      state.majors = { ...state.majors, avatar }
    }
  },
  getters: {
    major: (state) => {
      return state.major
    },
    courses: (state) => {
      return state.courses
    }
  }
}
